(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('logEventService', ['ajax', '$window', function (ajax, $window) {
            var logEventService = {};
            var ajaxConfig = {
                silent: true, // don't show error messages to the user
            };

            logEventService.addEvent = function (name, type) {
                var params = {
                    eventName: name,
                    eventType: type,
                };

                ajax.post('/api/addLogEvent', params, ajaxConfig).catch(function () {
                    if ($window.Bugsnag) {
                        Bugsnag.notify(new Error('Logging event ' + name));
                    }
                });
            };

            return logEventService;
        }]);
}());
